(function($) {
  'use strict';

  const equalizeHeights = ($slider, selector) => {
    const $items = $slider.find(selector);
    if ($items.length === 0) return;

    // Reset first so we can measure natural heights
    $items.each(function () {
      this.style.height = '';
    });

    let maxHeight = 0;
    $items.each(function () {
      this.style.height = 'auto';
      const height = $(this).outerHeight();
      if (height > maxHeight) maxHeight = height;
    });

    if (maxHeight > 0) {
      $items.each(function () {
        this.style.height = `${maxHeight}px`;
      });
    }
  };

const syncTestimonialHeights = ($slider) => {
  equalizeHeights($slider, '.main-testimonial-content');
  equalizeHeights($slider, '.testimonial-slide-item__title');
  equalizeHeights($slider, '.testimonial__title');
  equalizeHeights($slider, '.testimonial__author');
};

const requestSyncTestimonialHeights = ($slider) => {
  const existingTimeout = $slider.data('testimonialHeightSyncTimeout');
  if (existingTimeout) window.clearTimeout(existingTimeout);

  const timeoutId = window.setTimeout(() => {
    syncTestimonialHeights($slider);
  }, 50);

  $slider.data('testimonialHeightSyncTimeout', timeoutId);
};

const destroyTestimonialsSlider = ($slider) => {
  if (!$slider || $slider.length === 0) return;

  const existingTimeout = $slider.data('testimonialHeightSyncTimeout');
  if (existingTimeout) window.clearTimeout(existingTimeout);
  $slider.removeData('testimonialHeightSyncTimeout');

  $slider.off('.testimonialHeights');
  $slider.off('.testimonialVideos');

  if ($slider.hasClass('slick-initialized')) {
    try {
      $slider.slick('unslick');
    } catch (e) {
      // no-op
    }
  }
};

const initTestimonialsSlider = ($slider) => {
  if (!$slider || $slider.length === 0) return;

  // Ensure we can re-init safely (Theme Editor setting changes reload sections)
  destroyTestimonialsSlider($slider);

  $slider
    .on('init.testimonialHeights setPosition.testimonialHeights breakpoint.testimonialHeights afterChange.testimonialHeights', function () {
      requestSyncTestimonialHeights($(this));
    });

  $slider.slick({
      infinite: true,
      dots: true,
      centerMode: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      centerPadding: '0px',
      arrows: false,
      responsive: [
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '25%',
          }
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '15%',
          }


        }
      ]
  });

  // Pause only non-visible videos after slide changes
  $slider.on('afterChange.testimonialVideos', function() {
    pauseNonVisibleVideos();
  });

  // Initial sync
  requestSyncTestimonialHeights($slider);
};

// Track currently playing video
let currentlyPlayingVideo = null;

  function resetVideoUI(video) {
    const videoContainer = $(video).closest('.testimonial-video');
    const muteButton = videoContainer.find('.js-unmute-button');
    const playButton = videoContainer.find('.js-play-button');
    const poster = videoContainer.find('.testimonial-video__poster');
    
    muteButton.removeClass('is-playing');
    if (playButton.length) {
      playButton.show();
    }
    if (poster.length) {
      poster.fadeIn();
    }
    
    // Reset mute button state
    video.muted = true;
    muteButton.find('.icon-speaker-x-mark').show();
    muteButton.find('.icon-speaker-wave').hide();
    muteButton.attr('aria-label', 'Unmute video');
  }
  
  function pauseVideo(video) {
    video.pause();
    video.currentTime = 0;
    resetVideoUI(video);
    if (video === currentlyPlayingVideo) {
      currentlyPlayingVideo = null;
    }
  }
  
  function softPauseVideo(video) {
    // Pause without resetting position
    video.pause();
    const videoContainer = $(video).closest('.testimonial-video');
    const playButton = videoContainer.find('.js-play-button');
    if (playButton.length) {
      playButton.show();
    }
  }
  
  function pauseAllOtherVideos(exceptVideo) {
    // Pause ALL other videos when a new video is played (regardless of active slide)
    $('.js-testimonials-slider').find('video.shopify-video').each(function() {
      if (this !== exceptVideo && !this.paused) {
        pauseVideo(this);
      }
    });
  }
  
  function pauseNonVisibleVideos() {
    $('.js-testimonials-slider').find('video.shopify-video').each(function() {
      const video = this;
      const slide = $(video).closest('.slick-slide');
      const isVisible = slide.hasClass('slick-active');
      
      // Only pause if NOT on an active slide
      if (!isVisible && !video.paused) {
        pauseVideo(video);
      }
    });
  }
  
  function playVideo(video) {
    // Pause ALL other videos first (only one video can play at a time)
    pauseAllOtherVideos(video);
    
    const videoContainer = $(video).closest('.testimonial-video');
    const poster = videoContainer.find('.testimonial-video__poster');
    const playButton = videoContainer.find('.js-play-button');
    const muteButton = videoContainer.find('.js-unmute-button');
    
    // Check if video should start muted (default is unmuted)
    const startMuted = videoContainer.data('start-muted') === true;
    video.muted = startMuted;
    
    // Update mute button UI to match initial state
    if (startMuted) {
      muteButton.find('.icon-speaker-x-mark').show();
      muteButton.find('.icon-speaker-wave').hide();
      muteButton.attr('aria-label', 'Unmute video');
    } else {
      muteButton.find('.icon-speaker-x-mark').hide();
      muteButton.find('.icon-speaker-wave').show();
      muteButton.attr('aria-label', 'Mute video');
    }
    
    // Try to play
    const playPromise = video.play();
    
    if (playPromise !== undefined) {
      playPromise.then(() => {
        currentlyPlayingVideo = video;
        muteButton.addClass('is-playing');
        if (poster.length) {
          poster.fadeOut();
        }
        if (playButton.length) {
          playButton.hide();
        }
      }).catch(err => { 
        console.log('Video play failed:', err);
      });
    }
  }
  
  // Play/pause video on click (entire video area)
  $(document).on('click', '.js-testimonials-slider .testimonial-video--shopify', function (e) {
    const $target = $(e.target);
    
    // Don't trigger if clicking the mute button or shop button
    if ($target.closest('.js-unmute-button').length || $target.closest('.button').length) {
      return;
    }
    
    const videoContainer = $(this);
    const video = videoContainer.find('video.shopify-video')[0];
    
    if (video) {
      if (video.paused) {
        playVideo(video);
      } else {
        softPauseVideo(video);
      }
    }
  });

  $(document).on('click', '.js-testimonials-slider .js-unmute-button', function (e) {
    e.stopPropagation();

    const videoContainer = $(this).closest('.testimonial-video');
    const video = videoContainer.find('video.shopify-video')[0];
    
    if (video) {
      if (video.muted) {
        video.muted = false;
        $(this).find('.icon-speaker-x-mark').hide();
        $(this).find('.icon-speaker-wave').show();
        $(this).attr('aria-label', 'Mute video');
      } else {
        video.muted = true;
        $(this).find('.icon-speaker-x-mark').show();
        $(this).find('.icon-speaker-wave').hide();
        $(this).attr('aria-label', 'Unmute video');
      }
    }
  });

// Init on first load
$(function () {
  $('.js-testimonials-slider').each(function () {
    initTestimonialsSlider($(this));
  });
});

// Also resync after everything (fonts/images) settles.
$(window).on('load', function () {
  $('.js-testimonials-slider').each(function () {
    requestSyncTestimonialHeights($(this));
  });
});

// Shopify Theme Editor support
document.addEventListener('shopify:section:load', function (event) {
  const $section = $(event.target);
  // Delay to ensure DOM is fully rendered
  setTimeout(function() {
    const $slider = $section.find('.js-testimonials-slider');
    if ($slider.length) {
      $slider.each(function () {
        initTestimonialsSlider($(this));
      });
    }
  }, 100);
});

document.addEventListener('shopify:section:unload', function (event) {
  const $slider = $(event.target).find('.js-testimonials-slider');
  if ($slider.length) {
    $slider.each(function () {
      destroyTestimonialsSlider($(this));
    });
  }
});

// Handle block select/deselect (for when individual blocks are edited)
document.addEventListener('shopify:block:select', function (event) {
  const $section = $(event.target).closest('.section-testimonials-slider');
  if ($section.length) {
    const $slider = $section.find('.js-testimonials-slider');
    if ($slider.length && $slider.hasClass('slick-initialized')) {
      // Find the block index and go to that slide
      const $block = $(event.target);
      const $slide = $block.closest('.slick-slide');
      if ($slide.length) {
        const slideIndex = $slide.data('slick-index');
        if (typeof slideIndex === 'number') {
          $slider.slick('slickGoTo', slideIndex);
        }
      }
    }
  }
});

})(jQuery);